import { Body } from "@vds/typography";
import React from "react";
import styled from "styled-components";

const LegendWrapper = styled.div`
#legend,#text1{
    margin-bottom:10px ;
}
#text1Dot,#text2Dot,#text3Dot{
    margin-right:7px;
    height:9px;
    width:9px;   
    border-radius:50%;
    display:inline-block;
}
#text1Dot{
    background-color:#1e81b0;
}
#text2Dot{    
    background-color:#23b01e ;    
}
#text3Dot{    
    background-color:#5B8930 ;    
}
`;
class Legend extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
    }
    render() {

        return (<LegendWrapper>
            <Body size="small"
                color="#000000"
                id="legend"
                bold={true}
            >Legend</Body>
            {this.props.coords && this.props.coords.length == 0 ? <>
               <Body size="small"
                color="#000000"
                id="text1"
                bold={false}><span id="text1Dot"/>Your home</Body>
            <Body size="small"
                color="#000000"
                bold={false}><span id="text2Dot"/>5G Signal antennas</Body>
                </>
                : <>
            <Body size="small"
                color="#000000"
                bold={false}><span id="text3Dot"/>5G Signals can be accessed from these sides of your home.</Body>
                </>
            }
        </LegendWrapper>)
    }
}
export default Legend;
